import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../Containers/Config/index.js';
import { SLA_PAIN_MINUTES, SLA_PAIN_MINUTES_ERROR, SLA_PAIN_MINUTES_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* slaPainMinutes({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SLA_PAIN_MINUTES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SLA_PAIN_MINUTES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SLA_PAIN_MINUTES_ERROR, payload: error });
  }
}

export function* watchSlaPainMinutes() {
  yield takeEvery(SLA_PAIN_MINUTES, slaPainMinutes);
}

function* slaPainMinutesSaga() {
  yield all([fork(watchSlaPainMinutes)]);
}

export default slaPainMinutesSaga;
